// 工单状态
const orderStateList = [
  { name: '待受理', value: 0 },
  { name: '待指派', value: 1 },
  { name: '待接单', value: 2 },
  { name: '待服务', value: 3 },
  { name: '服务中', value: 4 },
  { name: '已完成', value: 5 },
  { name: '已取消', value: 6 }
]

// 工单优先级
const orderPriorityList = [
  { name: '一般', value: 1 },
  { name: '紧急', value: 2 },
  { name: '非常紧急', value: 3 }
]

// 模板类型
const templateType = [
  { name: '应用模板', value: 1 },
  { name: '回执模板', value: 5 },
  { name: '评价模板', value: 6 },
  { name: '回访模板', value: 4 }
]

// 自定义字段类型
const fieldType = [
  { name: '文本', value: 1 },
  { name: '数字', value: 2 },
  { name: '单选框', value: 3 },
  { name: '日期', value: 4 },
  { name: '时间', value: 5 },
  { name: '日期+时间', value: 6 },
  { name: '开关', value: 7 },
  { name: '多选框', value: 8 },
  { name: '地址选择器', value: 9 },
  { name: '图片', value: 10 },
  { name: '定位', value: 11 },
  { name: '扫码', value: 12 }
]

// 跟进节点
const followUpType = [
  { name: '试用开通', value: 1 },
  { name: '部署测试', value: 2 },
  { name: '管理推广', value: 3 },
  { name: '商务协商', value: 4 },
  { name: '款项到账', value: 5 }
]

module.exports = {
  orderStateList,           // 工单状态
  orderPriorityList,        // 工单优先级
  templateType,             // 模板类型
  fieldType,                // 字段类型
  followUpType              // 跟进节点
}

// 使用方法
// import { xxx } from '@/assets/globalData'
// data () {
//   return {
//     xxx
//   }
// }



// WEBPACK FOOTER //
// ./src/assets/globalData.js